import { useEffect, useState } from "react";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";
import { Card } from "@/components/ui/card";
import { api, formatApiErrorDetail } from "@/lib/api";

const persen = (v) => (v === null || v === undefined ? "–" : `${v.toLocaleString("id-ID")}%`);

// Jumlah sudah isi vs peserta Aktif SAAT INI per prodi & jenjang (angka saja, tanpa identitas).
export default function SurveiCakupan({ periodeId }) {
    const [data, setData] = useState(null);
    useEffect(() => {
        if (!periodeId) return;
        setData(null);
        api.get(`/survei/periode/${periodeId}/cakupan`)
            .then((r) => setData(r.data))
            .catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)));
    }, [periodeId]);

    if (!periodeId) return <p className="py-6 text-sm text-slate-500">Belum ada periode.</p>;
    if (!data) return <p className="py-6 text-sm text-slate-500">Memuat…</p>;
    return (
        <div className="space-y-4" data-testid="survei-cakupan">
            <p className="text-xs text-slate-500">Penyebut = peserta berstatus Aktif saat ini (bukan saat periode dibuka).</p>
            {data.jumlah_kode !== data.jumlah_jawaban && (
                <div role="alert" className="flex items-start gap-2 rounded-lg border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-100">
                    <AlertTriangle aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0" />
                    Tercatat {data.jumlah_kode} tanda sudah isi tetapi {data.jumlah_jawaban} jawaban tersimpan. Selisih terjadi bila penyimpanan jawaban gagal dan tandanya tidak sempat dibatalkan.
                </div>
            )}
            <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
                <Card className="p-4">
                    <div className="text-xs font-semibold uppercase text-slate-500">Semua jenjang</div>
                    <div className="text-2xl font-extrabold text-slate-900" data-testid="survei-cakupan-total">{data.total.sudah_isi} / {data.total.peserta_aktif}</div>
                    <div className="text-xs text-slate-500">{persen(data.total.persen)}</div>
                </Card>
                {data.per_jenjang.map((j) => (
                    <Card key={j.jenjang} className="p-4">
                        <div className="text-xs font-semibold uppercase text-slate-500">{j.jenjang}</div>
                        <div className="text-2xl font-extrabold text-slate-900">{j.sudah_isi} / {j.peserta_aktif}</div>
                        <div className="text-xs text-slate-500">{persen(j.persen)}</div>
                    </Card>
                ))}
            </div>
            <Card className="overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="compact w-full">
                        <thead className="bg-slate-100">
                            <tr className="text-left text-xs font-semibold uppercase tracking-wider text-slate-600">
                                <th>Program Studi / Modul</th><th>Jenjang</th><th className="text-right">Sudah isi</th>
                                <th className="text-right">Peserta Aktif</th><th className="pr-4 text-right">Cakupan</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.baris.length === 0 ? (
                                <tr><td colSpan={5} className="py-8 text-center text-slate-400">Belum ada data.</td></tr>
                            ) : data.baris.map((b) => (
                                <tr key={b.prodi_id || "-"} className="border-t border-slate-200">
                                    <td className="font-semibold text-slate-800">{b.nama}</td>
                                    <td className="text-xs">{b.jenjang}</td>
                                    <td className="text-right tabular-nums">{b.sudah_isi}</td>
                                    <td className="text-right tabular-nums">{b.peserta_aktif}</td>
                                    <td className="pr-4 text-right tabular-nums">{persen(b.persen)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Card>
        </div>
    );
}
